// TextModuleMeetingOverview.tsx
import React from 'react';
import {
  useGetMeetingEmailTemplates,
  useCreateMeetingEmailTemplate,
  useUpdateMeetingEmailTemplate,
  useDeleteMeetingEmailTemplate,
} from '../../hooks/reactQuerys/MeetingEmailTemplateQueries';
import {
  meetingEmailTemplateSchema,
  IMeetingEmailTemplate,
} from '../../Interfaces/IMeetingEmailTemplate';
import { LoadingSpinner } from '../../core/LoadingSpinner';
import { GenericMeetingEmailOverview } from '../../MeetingEmail/GenericMeetingEmailOverview';

export const TextModuleMeetingOverview: React.FC = () => {
  const { meetingEmailTemplates, isLoadingMeetingEmailTemplates } =
    useGetMeetingEmailTemplates();
  const { createMeetingEmailTemplate, isPendingCreateMeetingEmailTemplate } =
    useCreateMeetingEmailTemplate();
  const { updateMeetingEmailTemplate, isPendingUpdateMeetingEmailTemplate } =
    useUpdateMeetingEmailTemplate();
  const { deleteMeetingEmailTemplate, isPendingDeleteMeetingEmailTemplate } =
    useDeleteMeetingEmailTemplate();

  const rows = (meetingEmailTemplates ?? []).filter(
    t => t.idLegalTransactionType == null
  );

  const handleSave = async (tpl: IMeetingEmailTemplate) => {
    const payload = {
      ...tpl,
      sendOnCreation: Boolean(tpl.sendOnCreation),
      sendOnReschedule: Boolean(tpl.sendOnReschedule),
      sendOnCancelling: Boolean(tpl.sendOnCancelling),
      sendWithCalenderFile: Boolean(tpl.sendWithCalenderFile),
      allowDataUpload: Boolean(tpl.allowDataUpload),
    };
    if (payload.idMeetingEmailTemplate > 0) {
      await updateMeetingEmailTemplate(payload);
    } else {
      const { idMeetingEmailTemplate, ...rest } = payload;
      await createMeetingEmailTemplate(rest);
    }
  };

  const handleDelete = async (tpl: IMeetingEmailTemplate) => {
    if (tpl.idMeetingEmailTemplate > 0) {
      await deleteMeetingEmailTemplate(tpl.idMeetingEmailTemplate);
    }
  };

  if (
    isLoadingMeetingEmailTemplates ||
    isPendingCreateMeetingEmailTemplate ||
    isPendingUpdateMeetingEmailTemplate ||
    isPendingDeleteMeetingEmailTemplate
  ) {
    return <LoadingSpinner />;
  }

  return (
    <GenericMeetingEmailOverview<IMeetingEmailTemplate>
      title='Termin-E-Mails'
      rows={rows}
      getId={(item: { idMeetingEmailTemplate: any }) =>
        item.idMeetingEmailTemplate
      }
      createEmpty={() => meetingEmailTemplateSchema.parse({})}
      onSave={handleSave}
      onDelete={handleDelete}
    />
  );
};
